import { render, staticRenderFns } from "./WorkIconEdit.vue?vue&type=template&id=574e399a"
import script from "./WorkIconEdit.vue?vue&type=script&lang=js"
export * from "./WorkIconEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports